import { baseUrl } from '../api/baseUrl';


function handlePrintPickupOrder(poNumber: string, secret?: string): void {

  let url: string = `${baseUrl}pickup_order/${poNumber}/file`;

  if (secret) {
    url += `?key=${secret}`;
  }

  window.open(url);
}

function handlePrintProofOfDelivery(type: string, awbCode: string, awbNumber: string, version: number): void {

  window.open(`${baseUrl}awb/${awbCode}/${awbNumber}/${version}/pod/file`);
}

export {
  handlePrintPickupOrder,
  handlePrintProofOfDelivery
}